import { useIonActionSheet } from '@ionic/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Machine, MachineConnectionType } from '../../api/graphql/generated';
import { useDirectConnectNavigateToMachine } from '../../direct-connect/helper/direct-connect-helper';
import { useBeaconRouter } from '../../route/route.hooks';
import { ProgramState, SafetyState } from './machine-state';

export const isProgramStopped = (
  programState: ProgramState | string
): boolean => {
  return programState
    ? programState !== ProgramState.PROGRAM_PLAYING &&
        programState !== ProgramState.PROGRAM_PAUSED &&
        programState !== ProgramState.PROGRAM_PAUSING
    : true;
};

export const isProgramState = (
  machine: Machine,
  programStates: ProgramState[]
): boolean => {
  return (
    programStates.find(
      (programState) =>
        programState === machine?.state?.transient?.status?.programState
    ) !== undefined
  );
};

export const isSafetyState = (
  machine: Machine,
  safetyStates: SafetyState[]
): boolean => {
  return (
    safetyStates.find(
      (safetyState) =>
        safetyState === machine.state?.transient?.status?.safetyState
    ) !== undefined
  );
};

export const useNavigateToMachine = () => {
  const { i18n } = useTranslation();

  const { builder } = useBeaconRouter();
  const { push } = useHistory();

  const [presentActions] = useIonActionSheet();
  const navigateToDirectConnect = useDirectConnectNavigateToMachine();

  const callback = useCallback(
    (machine: Machine) => {
      const isDirectConnect =
        machine.connectionType === MachineConnectionType.DIRECT;
      const cloudRoute = builder.getMachineRoute(machine.teamId, machine.id);

      if (!isDirectConnect) {
        push(cloudRoute);
        return;
      }

      presentActions(
        [
          {
            text: i18n.t('common:app_mode_cloud_title'),
            handler: () => {
              push(cloudRoute);
            },
          },
          {
            text: i18n.t('common:app_mode_direct_title'),
            handler: () => {
              navigateToDirectConnect(machine);
            },
          },
          {
            text: i18n.t('common:cancel'),
            role: 'cancel',
          },
        ],
        i18n.t('common:direct_connect_select_description')
      );
    },
    [i18n, presentActions, push, builder, navigateToDirectConnect]
  );

  return callback;
};
